import React, {forwardRef} from "react"
import styled from "styled-components";

const StyledInputContainer = styled.div`
    //width: 200px;
    //height:40px;
    height: ${props => props.$height ? props.$height : '40px'};
    width:  ${props => props.$width ? props.$width : '200px'};
    

    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid #E0E0E0;
    display: flex;
    align-items: center;
    gap: 5px;
    font: 600 14px/1.5 Pretendard;
    background-color: ${props => props.$readOnly ? '#EEEEEE' : '#FFFFFF'};

    /* margin prop 추가 및 기본값 설정 */
    margin-top: ${props => props.$marginTop || '0'}; 
    margin-bottom: ${props => props.marginBottom || '0'};
    margin-left: ${props => props.$marginLeft || '0'}; 
    margin-right: ${props => props.$marginRight || '0'};

    &:hover,
    &:focus-within {
        border: 1px solid #1C1C1C;
    }

    transition: all 0.3s ease; /* 애니메이션 천천히 */

    input {
        font: 400 15px/1.5 Pretendard;
        flex-grow: 1;
        min-width: 0;
        padding: 0;
        border: none;
        outline: none;
        box-sizing: border-box;

        color: ${props => props.$readOnly ? '#BBBBBB' : '#555555'};;

        &:hover,
        &:focus {
            border: 0;
            outline: none;
        }
    }

    span {
        margin-left: auto;
        white-space: nowrap;
        color: ${props => props.$readOnly ? '#BBBBBB' : '#555555'};;
    }
`;

const InputUnitText = forwardRef(({
                                    type = "text",
                                    maxLength,
                                    value = "",
                                    onChange,
                                    readOnly = false,
                                    unit = "",
                                    width = "200px",
                                    height = "40px",
                                    marginTop = 0,
                                    marginBottom = 0,
                                    marginLeft = 0,
                                    marginRight = 0,
                                    isInteger = false
                                  }, ref) => {

  const inputMaxLength = maxLength ?? (isInteger || type === "number" ? 6 : 10);

  const handleChange = (e) => {
    if (!onChange) return;

    let inputValue = e.target.value;

    // 1. isInteger = true 일 때 (순수 정수형: 숫자만 허용, 소수점 금지)
    if (isInteger) {
      inputValue = inputValue.replace(/[^0-9]/g, "");
    }
    // 2. type = "number" 일 때 (실수형 가능: 숫자와 마침표(.) 하나만 허용, 알파벳 e 제거)
    else if (type === "number") {
      // 숫자와 마침표(.) 외에는 전부 제거
      inputValue = inputValue.replace(/[^0-9.]/g, "");

      // 소수점이 여러 개 찍히는 버그 방지 (예: 1.2.3 -> 1.23)
      const splitValues = inputValue.split('.');
      if (splitValues.length > 2) {
        inputValue = splitValues[0] + '.' + splitValues.slice(1).join('');
      }
    }

    // 3. 글자 수 제한 체크 (maxLength보다 길면 칼같이 자르기)
    if (inputValue.length > inputMaxLength) {
      inputValue = inputValue.slice(0, inputMaxLength);
    }

    // 가공이 완료된 값을 부모에게 전달
    onChange(inputValue);
  };

  return (
    <StyledInputContainer
      $readOnly={readOnly}
      $marginTop={marginTop}
      $marginBottom={marginBottom}
      $marginLeft={marginLeft}
      $marginRight={marginRight}
      $width={width}
      $height={height}
    >
      <input
        // 알파벳 e로 인해 maxLength가 풀리는 현상을 막기 위해 둘 다 "text"로 브라우저를 속입니다.
        type={(type === "number" || isInteger) ? "text" : type}

        // 모바일에서 숫자 키패드가 뜨도록 지원
        inputMode={(type === "number" || isInteger) ? "numeric" : undefined}

        maxLength={inputMaxLength}
        ref={ref}
        readOnly={readOnly}
        value={value || ""}
        onChange={handleChange}
      />
      {unit && <span>{unit}</span>}
    </StyledInputContainer>
  );
});

export default InputUnitText;